import { Modal } from "@/frontend/shared/ui/Modal";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./DeleteCompanyModal.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { deleteCompany } from "../../../model/deleteCompany";
import { snackbarConstructor } from "@/frontend/shared/ui/CustomNotifications/ui/Snackbar/snackbarConstructor";
import { deleteCompanies } from "../../../model/deleteCompanies";
import { useState } from "react";
import { ConfirmationModal } from "@/frontend/shared/ui/ConfirmationModal/ConfirmationModal";

interface DeleteCompanyModalProps {
  isOpen: boolean;
  id: number;
  triggerRefetch: () => void;
  onClose: () => void;
}

export function DeleteCompanyModal({ isOpen, id, triggerRefetch, onClose }: DeleteCompanyModalProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  async function deleteCompanyOnClick() {
    setIsDeleting(true);
    await deleteCompanies([id])
      .then(() => {
        triggerRefetch();
        snackbarConstructor("Successfully deleted company", "normal");
      })
      .finally(() => {
        setIsDeleting(false);
      })
      .catch((error) => {
        snackbarConstructor("Error deleting company", "error");
        console.error("Error:", error);
      });

    onClose();
  }

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={deleteCompanyOnClick}
      title="Remove company from pipeline?"
      content="Removing this company will take it out of the pipeline permanently. No data will be deleted, but the company will no longer appear in the pipeline."
      dangerConfirm
      confirmButtonText="Remove"
      isDisabled={isDeleting}
    />
  );
}
